module.exports = __webpack_public_path__ + "img/ic_ex2.06fecf44.svg";